import React from 'react';
import { products } from '../data/mock';

const Products = () => {
  return (
    <section id="products" className="products-section">
      <div className="container">
        
        {/* Header matching Emergent design */}
        <div className="products-header">
          <p className="products-subtitle">OUR PRODUCTS</p>
          <h2 className="products-title">Premium Tea Premixes</h2>
          <p className="products-desc">
            Discover our carefully crafted tea premixes, ready to brew the perfect cup.
          </p>
        </div>

        {/* Updated Grid & Cards */}
        <div className="products-grid">
          {products.map((product, index) => (
            <div key={product.id} className="product-card">
              
              <div className="product-image-container">
                <img src={product.image} alt={product.name} />
                <span className="product-price-badge">₹{249 + (index * 50)}</span>
              </div>
              
              <div className="product-info">
                <h3>{product.name}</h3>
                <p>{product.description}</p>
                {/* The View Details button has been removed from here! */}
              </div>
              
            </div>
          ))}
        </div>

        {/* Centered Bottom Button */}
        <div className="products-footer">
          <button className="btn-primary" style={{ padding: '14px 32px', fontSize: '1.05rem' }}>
            View All Products →
          </button>
        </div>

      </div>
    </section>
  );
};

export default Products;